import { ca } from '@cian/analytics';

import { type TReduxStore } from '@/microfrontends/filters/shared/store';
import { getUser } from '@/microfrontends/filters/shared/store/thunks/user';
import { getTrackingUser } from '@/microfrontends/filters/shared/utils/analytics/getTrackingUser';

import { EUserEventType, type TUserEvent } from '../types/user';

interface IEventHandlerParams {
  reduxStore: TReduxStore;
}

export function createAuthenticationEventHandler({ reduxStore }: IEventHandlerParams) {
  return async function authenticationEventHandler(event: TUserEvent): Promise<void> {
    if (typeof window === 'undefined') {
      return;
    }

    switch (event.type) {
      case EUserEventType.Authenticated: {
        await reduxStore.dispatch(getUser());

        ca('user', getTrackingUser(reduxStore.getState()));

        break;
      }
    }
  };
}
